export const EMAIL_FIELD_NAME = 'email';

export const TEST_ID = 'inviteUserForm';

export const CONFIRM = 'confirm';
